<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('工单流程管理')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="tplsName" slot-scope="tplsName">
          <span>
            <a-tag :key="tag" color="geekblue" v-for="tag in tplsName">{{ tag }}</a-tag>
          </span>
        </template>
        <template slot="taskName" slot-scope="taskName">
          <span>
            <a-tag :key="tag" color="#55acee" v-for="tag in taskName">{{ tag }}</a-tag>
          </span>
        </template>

        <template slot="notice" slot-scope="notice">
          <span>
            <a-tag :key="tag" color="green" v-for="tag in notice">{{ tag == '1' ? '邮件' : '' }}</a-tag>
          </span>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <p-process-info-modal @ok="modalFormOk" ref="modalForm"></p-process-info-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PProcessInfoModal from './modules/PProcessInfoModal'

  export default {
    name: 'PProcessInfoList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      PProcessInfoModal
    },
    data () {
      return {
        description: '工单流程管理管理页面',
        // 表头
        columns: [{
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '流程名称',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: '工单分类',
          align: "center",
          dataIndex: 'classifyName'
        },
        {
          title: '工单模板',
          align: "center",
          dataIndex: 'tplsName',
          scopedSlots: { customRender: 'tplsName' }
        },
        {
          title: '任务',
          align: "center",
          dataIndex: 'taskName',
          scopedSlots: { customRender: 'taskName' }
        },
        {
          title: '提交统计',
          align: "center",
          dataIndex: 'submitCount'
        },
        {
          title: '绑定通知',
          align: "center",
          dataIndex: 'notice',
          scopedSlots: { customRender: 'notice' }
        },
        {
          title: '备注',
          align: "center",
          dataIndex: 'remarks'
        },
        {
          title: '创建人',
          align: "center",
          dataIndex: 'createBy'
        },
        {
          title: '创建日期',
          align: "center",
          dataIndex: 'createTime',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          fixed: "right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
        ],
        url: {
          list: "/workorder/pProcessInfo/list",
          delete: "/workorder/pProcessInfo/delete",
          deleteBatch: "/workorder/pProcessInfo/deleteBatch",
          exportXlsUrl: "/workorder/pProcessInfo/exportXls",
          importExcelUrl: "workorder/pProcessInfo/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'id', text: '主键标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'name', text: '流程名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'classifyId', text: '流程工单分类id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tpls', text: '流程工单模板', dictCode: '' })
        fieldList.push({ type: 'string', value: 'taskId', text: '流程任务ID, array, 可执行多个任务，可以当成通知任务，每个节点都会去执行', dictCode: '' })
        fieldList.push({ type: 'string', value: 'submitCount', text: '流程提交统计', dictCode: '' })
        fieldList.push({ type: 'string', value: 'notice', text: '流程绑定通知', dictCode: '' })
        fieldList.push({ type: 'string', value: 'remarks', text: '流程备注', dictCode: '' })
        fieldList.push({ type: 'string', value: 'createBy', text: '创建人', dictCode: '' })
        fieldList.push({ type: 'date', value: 'createTime', text: '创建日期' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>